import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { LoaderComponent } from '../../../pages/loader/loader.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { ajaxservice } from '../../../../services/ajaxservice';
import { formatDate } from '@angular/common';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { ToastrService } from 'ngx-toastr'
import { ExcelService } from '../../../../services/excelservice';
import moment from 'moment';
import { NgbModal, NgbDate, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { HttpResponse } from '@angular/common/http';
import { assign } from 'lodash';
import { concatAll } from 'rxjs/operators';
import { C } from '@angular/cdk/keycodes';
import { title } from 'process';
import { TicketdetailsComponent } from '../../all-shared/ticketdetails/ticketdetails.component';
declare var $: any;

@Component({
  selector: 'kt-allticket',
  templateUrl: './allticket.component.html',
  styleUrls: ['./allticket.component.scss'],
  providers: [TicketdetailsComponent]
})
export class AllticketComponent implements OnInit {
  cusCode: string;
  cusName: string;
  assetStatus: any[];
  customer_details: any[];
  customerid_settings:any={}
  dropdownFacilityDepartSettings:any={}
  facility_department: any;
  facility_depart_id: any=[];
  facilityDepartId: any=[];
  ticketFiltter:FormGroup;
  LoaderComponentPortal: ComponentPortal<LoaderComponent>;
  @ViewChild('dataTables', { static: true }) table;
  overlayRef: OverlayRef;
  error: string;
  showAssetHistory: boolean;
  pageLoader: boolean;
  assetStatusReportData: any[];
  currentPage1: number=1;
  totalRecords1: any;
  endRecord1: any;
  startRecord1: any;
  showFilters: boolean;
  search_value: string;
  searchError: string;
  selectedItemsPerPage1: number=50;
  defaultTo: any;
  defaultFrom: any;
  to: any;
  ticket_details: any;
  searchValue: string;
  showAllTicketTable: boolean;
  tableHeight: any;
  itemsPerPage1: any;
  from: any;
  return_draw: number;
  pagination_flag: boolean;
  statusList:any;
  duration_period: boolean=false;
  searchValue1: string;
	ticket_id: any;
	falg: any;
	pageFilter: any;
  public onDateRangeSelection(range: { from: Date, to: Date }) {
		this.from = range.from;
		this.to = range.to;
	}
constructor(private ajax: ajaxservice, private overlay: Overlay, private calendar: NgbCalendar, private toastr: ToastrService, private chRef: ChangeDetectorRef, 
    private excelservice: ExcelService,private modalService: NgbModal,private sanitizer: DomSanitizer,private fb: FormBuilder) { 
    this.ticketFiltter = new FormGroup({
      asset_status_id:new FormControl([],Validators.required),
      customer_name:new FormControl('1',Validators.required),
      FacilityDepart:new FormControl('',Validators.required),
      selected_period:new FormControl((localStorage.getItem('durartion')),Validators.required),
      status:new FormControl('All',Validators.required)
    });
    this.defaultTo = new Date();
    this.defaultFrom = (new Date().getMonth() + 1) + '.' + '01' + '.' + (new Date().getFullYear());
    this.to = this.calendar.getToday();
  }
  ngOnInit(): void {
    this.cusCode= localStorage.getItem('reg_cust_code')
    this.cusName= localStorage.getItem('reg_cust_name')
    this.getFacilityDepartment();
    this.assetStatus = [
      {'assetStatusId':'Functional Equipment','assetStatusValue':'Functional'},
      {'assetStatusId':'Non Functional Equipment','assetStatusValue':'Not-Functional'},
      {'assetStatusId':'BER','assetStatusValue':'BER'}
    ];
    this.customer_details = [
      {'customer_code':this.cusCode,'customer_name':this.cusName}
    ];
    this.statusList=[
			{ "id": 'All',"name": "All"},
			{ "id": "closed","name": "Closed"},
			{ "id": 'completed',"name": "Completed"},
			{ "id": 'pending',"name": "Pending"},
			{ "id": 'ber',"name": "BER"}
		];
    // this.LoaderComponentPortal = new ComponentPortal(LoaderComponent);
    // Facility Department settings
	this.pageFilter =localStorage.getItem('pageFilter');
    if(this.pageFilter==1){
		this.ticketFiltter.controls['status'].setValue('All');
    }else if(this.pageFilter==2){
		this.ticketFiltter.controls['status'].setValue('completed');
    }else{
		this.ticketFiltter.controls['status'].setValue('pending');
    }
    this.customerid_settings = {
      singleSelection: false,
      idField: 'customer_code',
      textField: 'customer_name',
      selectAllText: 'Select Facility name',
      unSelectAllText: 'UnSelect Facility name',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    // Facility Department settings
    this.dropdownFacilityDepartSettings ={
      singleSelection: false,
      idField: 'device_class_id',
      textField: 'device_class',
      selectAllText: 'Select Facility Department',
      unSelectAllText: 'UnSelect Facility Department',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
			this.defaultTo= localStorage.getItem('toDate');
			this.defaultFrom = localStorage.getItem('fromDate');
      this.to = this.defaultTo;
      this.from= this.defaultFrom;
			if((localStorage.getItem('durartion')!='MTD'&&localStorage.getItem('durartion')!='QTD'&&localStorage.getItem('durartion')!='YTD')){
			  this.duration_period = true;
			}
    setTimeout(() => {
      // this.districtId=[]
      // this.facilityNatureId=[];
      // this.facilityDepartId=[]
      // this.facilityTypeId=[]
      // this.assetStatusId=[]
      // this.equipmentNameId=[]
      // this.contractId=[]
      // this.customer_code=[]
      this.getAttendance(this.currentPage1, this.itemsPerPage1, this.searchValue1);
    },1000)
  }
   // single select AssetStatus functionality
   onItemSelectFacilityDepart(items: any) {
    (this.facility_department.length!=this.facility_depart_id.length)?this.facility_depart_id=this.facility_depart_id:this.facility_depart_id=[];
    this.facility_depart_id.push(items.device_class_id);
    this.facilityDepartId = this.facility_depart_id;
  }
  // allselect AssetStatus functionality
  onSelectAllFacilityDepart(items: any) {
    this.facility_depart_id = [];
    this.facility_depart_id =[];
    var isPresent = this.facility_depart_id.some(function (el) { return el === items.device_class_id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.facility_depart_id.push(value.device_class_id);
      })
    };
    this.facilityDepartId = this.facility_depart_id;
  }
  // single deselect AssetStatus functionality
  onItemDeSelectFacilityDepart(items: any) {
    const index: number = this.facility_depart_id.indexOf(items.device_class_id);
    if (index !== -1) {
      this.facility_depart_id.splice(index, 1);
    }
    this.facilityDepartId = this.facility_depart_id;
  }
  // all deselect AssetStatus functionality
  onItemDeSelectAllFacilityDepart(items: any) {
    this.facilityDepartId = [];
    this.facility_depart_id =[];
  }
  // Facility Department
  getFacilityDepartment() {
    var url = 'get_faciility_department/';
    this.ajax.getdata(url).subscribe((result) => {
      if(result.response.response_code == '200' || result.response.response_code == '400') {
        this.facility_department = result.response.data;
        this.facility_department.filter(facilityDepartment=>{this.facilityDepartId.push(facilityDepartment.device_class_id)})
      } else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');
      } else {
        this.toastr.error("Something went wrong", 'Error');
      }
    }, (err) => {
      console.log(err);                                             //prints if it encounters an error
    });
  }
  search(value: any, itemsPerPage1: any, page: number) {
		if((this.ticket_details.length!=0 && this.searchValue !='')||this.ticket_details.length==0){
			this.overlayRef.attach(this.LoaderComponentPortal);
			this.searchError ='';
			this.showAllTicketTable = false;
			if ($.fn.DataTable.isDataTable('#normalDatatables')) {
				this.table.destroy(); // Destroy the current DataTable instance
				$('#normalDatatables').empty(); // Clear the DOM content
			}
			const data = {
				// "product_id": (this.ProductLocation.value.product_id==null)?"All":this.ProductLocation.value.product_id,
				// "location_id": (this.ProductLocation.value.location_id==null)?'All':this.ProductLocation.value.location_id,
				// "customer_code": this.customer_code,
				// "status": (this.status_id.length != 0) ? this.status_id : 'All',
				// "length": itemsPerPage1,
				// "start": itemsPerPage1 * (page - 1),
				// "draw": page - 1,
				// "search_value": value,
				// "sort": "",
				// "column": "",
				// "role": this.role_id,
				// "employee_id": this.employee_code,
				// "product_id": this.productId,
				// "state_id": this.stateId,
				// "district": this.districtId,
				// "facility_nature": this.facilityNatureId,
				// "facility_dept": this.facilityDepartId,
				// "facility_type": this.facilityTypeId,
				// "equipment_name": this.equipmentNameId,
				// "contract_type":this.contractId,
				// "duration":this.ProductLocation.value.selected_period,
				// "from_date":(this.ProductLocation.value.selected_period!="")?"":this.from,
				// "to_date":(this.ProductLocation.value.selected_period!="")?"":this.to,
// 
			}
			var url = 'get_datebase_tickets/'                                 //api url
			this.ajax.postdata(url, data).subscribe((result) => {        // added cus type ,productid location id sowmiya
				if (result.response.response_code == "200" || result.response.response_code == "400") {
					this.ticket_details = result.response.data;                    // storing the api response in the array
					this.totalRecords1 = result.response.pagination.total;
					this.endRecord1 = result.response.pagination.to;
					this.startRecord1 = result.response.pagination.from;
					this.currentPage1 = result.response.pagination.current_page
					setTimeout(() => {
						if ($.fn.dataTable.isDataTable("#normalDatatables")) {
							const table = $('#normalDatatables').DataTable();
							table.clear();               // Clear current data
							table.rows.add(this.ticket_details);          // Add new data
							table.page(this.currentPage1 - 1).draw(false); // Set page index and redraw
						}
						else {         // Initialize DataTable
							this.initializeassetDataTable(page, itemsPerPage1);
						}
					},);
					this.showAllTicketTable = true;
					this.chRef.detectChanges();
					this.overlayRef.detach();
				}
				else if (result.response.response_code == "500") {
					this.error = result.response.message;
					this.overlayRef.detach();
				}
				else {
					this.error = "Something Went Wrong";
					this.overlayRef.detach();
				}
			}, (err) => {
				console.log(err);                                                 // prints if it encounters an error
				this.overlayRef.detach();
			});
		}else{
			this.searchError = "Please Enter Search Value"
		}
	}
	initializeassetDataTable(page: number, itemsPerPage: any) {
		this.table = $('#normalDatatables').DataTable({
			searching: false, // Enable search functionality
			pagingType: 'full_numbers',
			pageLength: this.selectedItemsPerPage1,
			lengthMenu: [50, 100, 150, "All"],
			language: {
				zeroRecords: 'No Data Available',
			},
			scrollY: this.tableHeight,                             //for individual scroll inside table // sowmiya //feb19-2025
			scrollX: true,
			scroller: true,
			data: this.ticket_details, // Pass the data here
			columns: [
				{ data: null, title: '#', render: (data, type, row, meta) => meta.row + 1 }, // Serial number column
				{
					data: 'ticket_id', title: 'MPT ID', defaultContent: '-', render: (data, type, row) => {
						// Render ticketid as a clickable element with tooltip
						return `<span class="linkButton"  data-action="ticket_id"  title="Click to view details">${row.ticket_id}</span>`;
					},
				},
				{
					data: 'serial_no', title: 'Barcode', render: (data, type, row) => {
						// Render barcode as a clickable element with tooltip
						return `<span   data-action="barcode"  title="Click to view details">${row.serial_no}</span>`;
					},
				},
				{ data: 'customer_name', title: 'Facility Name', defaultContent: '-' },
				{ data: 'City', title: 'District Name', defaultContent: '-' },
				{ data: 'equipment_name', title: 'Equipment Name', defaultContent: '-' },
				{ data: 'part_number', title: 'Device Model', defaultContent: '-' },
				{ data: 'equipment_serial', title: 'Equipment Serial', defaultContent: '-' },
				{
					data: 'technician_name', title: 'Assinged BME', defaultContent: '-', render: (data, type, row) => {
						// Render technician as a clickable element with tooltip
						return `<span data-action="technician_name"  title="Click to view details">${row.ticket_id, row.technician_name}</span>`;
					},
				},
				{ data: 'raised_date_time', title: 'Registation Date', defaultContent: '-' },
				{ data: 'ticket_age', title: 'Ticket Age', defaultContent: '-' },
				{ data: 'equipment_status', title: 'Equipment Status', defaultContent: '-' },
				{ data: 'status', title: 'Main Status', defaultContent: '-' },
				{ data: 'status_name', title: 'Sub Status', defaultContent: '-' },
				{ data: 'remarks', title: 'Remark', defaultContent: '-',render: (data, type, row) => {
					return `<span style="word-wrap: break-word; white-space: normal; width: 200px; display: block;">${data}</span>`;
				  }},
				// {
				// 	data: 'resolution_image', title: 'Attachment', defaultContent: '-', orderable: false, // Disable sorting for this column
				// 	render: (data, type, row) => {
				// 		return ` <a class="cur"  > <img src="assets/media/icons/png/attachment.png"> </a>`;
				// 	}
				// },
				// { data: 'status_name', title: 'status', defaultContent: '-' },
			],
			rowCallback: (row: Node, data: any, index: number) => {
				const htmlRow = row as HTMLElement; // Cast Node to HTMLElement
				const actionLinks = htmlRow.querySelectorAll('.linkButton') as NodeListOf<HTMLElement>;
				actionLinks.forEach((link) => {
					link.addEventListener('click', () => {
						const action = link.getAttribute('data-action');
						if (action === 'ticket_id') {
							this.get_ticket_details(data.ticket_id)
						} else if (action === 'barcode') {
							// this.get_barocde_details(data.serial_no); // Call Angular method for barcode details
						} else if (action === 'technician_name') {
							// this.get_technician_details(data.ticket_id, data.technician_id, this.view_techniciandetails)
						}
					});
				});
				const attach = htmlRow.querySelector('.cur') as HTMLElement;
				if (attach) {
					attach.addEventListener('click', () => {
						// this.attachments(data, this.attachmentPage)
					});
				}
			},
			drawCallback: () => {
				this.updatePaginationNumbers();
			},
		});
		// this.getTableDetails()
		// Handle page changes
		$('#normalDatatables').off('page.dt').on('page.dt', (search: string) => {
			const info = this.table.page.info();
			this.pagechange(info.page + 1, this.selectedItemsPerPage1, search);
		});
		$('#normalDatatables').off('length.dt').on('length.dt', (e: any, settings: any, len: number, search: string) => {
			this.selectedItemsPerPage1 = (len!=100&&len!=150&&len!=50)?50:len;
			this.pagechange(1, len, search);
		});
		$('#normalDatatables_wrapper .dataTables_info').remove();
		$('#normalDatatables_wrapper .dataTables_paginate').remove();
	}
	updatePaginationNumbers() {
		this.startRecord1 = this.currentPage1;
		this.endRecord1 = this.totalRecords1;
	}
	pagechange(page: number, itemsPerPage: any, search: string) {
		this.currentPage1 = page;
		this.itemsPerPage1 = itemsPerPage; // Update the items per page if applicable
		this.getAttendance(page, itemsPerPage, search);
	}
	getAttendance(page: number, itemsPerPage1: any, search: string) {
    this.ticketFiltter.controls['customer_name'].setValue('1');
		this.searchError = '';
		this.showAllTicketTable = false;
		// this.overlayRef.attach(this.LoaderComponentPortal); //attach loader		
		this.ticket_details = [];
		this.from = moment(this.from).format('YYYY-MM-DD');
		this.to = moment(this.to).format('YYYY-MM-DD');
		this.return_draw = 0;
		this.pageFilter=''
		var data = {
			"customer_code": [this.cusCode],
			"status":this.ticketFiltter.value.status,
			"length": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?'All':itemsPerPage1,
			"start": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?50:itemsPerPage1 * (page - 1),
			"draw": page - 1,
			"search_value": search || '', // Sort direction,
			"sort": "",
			"column": "",
			"facility_dept": this.facilityDepartId,
			"duration":this.ticketFiltter.value.selected_period,
			"from_date":(this.ticketFiltter.value.selected_period!="")?"":this.from,
			"to_date":(this.ticketFiltter.value.selected_period!="")?"":this.to,
		}
		// if(this.linkFlag){
		// 	this.service_groupId = (localStorage.getItem('reportserviceGroup')!='' && localStorage.getItem('reportserviceGroup')!="All")?localStorage.getItem('reportserviceGroup').split(',').map(Number):[];
		// 	this.technicianId = (localStorage.getItem('reportTechnicianId')!='' && localStorage.getItem('reportTechnicianId')!="All")?localStorage.getItem('reportTechnicianId').split(',').map(Number):[];
		// 	this.service_group_id = this.service_groupId
		// 	this.newData = { ...data, service_group: this.service_groupId ,technician_id:this.technicianId};
		// }else if(this.assetLink){
		// 	this.service_groupId = (localStorage.getItem('reportserviceGroup')!='' && localStorage.getItem('reportserviceGroup')!="All")?localStorage.getItem('reportserviceGroup').split(',').map(Number):[];
		// 	this.service_group_id = this.service_groupId
		// 	this.newData = { ...data, service_group: this.service_groupId};
		// }else{
		// 	this.newData = {...data,service_group:this.service_groupId}
		// 	this.service_group_id = this.service_groupId
		// }
		var url = "facility_ticketdetails/";                              // api url for getting the cities
		this.ajax.postdata(url, data).subscribe((result) => {
			this.pagination_flag = false;
			if (result.response.response_code == "200" || result.response.response_code == "400") {
				this.ticket_details = result.response.data;
				this.totalRecords1 = result.response.pagination.total;
				this.endRecord1 = result.response.pagination.to;
				this.startRecord1 = result.response.pagination.from;
				this.currentPage1 = result.response.pagination.current_page
				// if (result.response.recordsTotal <= 500) {
				setTimeout(() => {
					if ($.fn.dataTable.isDataTable("#normalDatatables")) {
						const table = $('#normalDatatables').DataTable();
						table.clear();               // Clear current data
						table.rows.add(this.ticket_details);          // Add new data
						table.page(this.currentPage1 - 1).draw(false); // Set page index and redraw
					}
					else {         // Initialize DataTable
						this.initializeassetDataTable(page, 1);
					}
				},);
				this.showAllTicketTable = true
				this.pagination_flag = true;
				this.chRef.detectChanges();
				// this.overlayRef.detach();
			}
			else if (result.response.response_code == "500") {
				// this.overlayRef.detach();
			}

			else {
				// this.overlayRef.detach();
				this.toastr.error(result.response.message, 'Error');
			}
		},
			(err) => {
				console.log(err);                                        //prints if it encounters an error
			});
	}
  // period change
onChangePeriod(value){
  console.log(this.defaultFrom,this.defaultTo,"427")
	if(value == ''){
		this.duration_period = true;
	}
	else{
		this.duration_period = false;
	}
}
reset_filters() {
  this.searchValue = '';
  this.searchError = '';
  this.from = this.defaultFrom;
  let date: Date = new Date(this.defaultFrom);
  this.defaultFrom = date;
  this.defaultTo = new Date();
  this.to = this.defaultTo;
  // this.status_id = this.stateId;
  this.ticketFiltter.reset()
  this.facilityDepartId = [];
  this.ticketFiltter.controls['selected_period'].setValue('MTD');
  this.ticketFiltter.controls['status'].setValue('All');
  setTimeout(() => {
    this.getAttendance(this.currentPage1, this.itemsPerPage1, this.searchValue1);
  },1000)
  this.chRef.detectChanges();
}
// ticket details based on TicketId 
get_ticket_details(tickt_id) {
	this.ticket_id = tickt_id
	const modalRef: NgbModalRef = this.modalService.open(TicketdetailsComponent, {
		size: 'lg', //specifies the size of the dialog box
		windowClass: "center-modalcontract",
		backdrop: 'static',              //popup outside click by Sowndarya
		keyboard: false
	});
	modalRef.componentInstance.ticket_id = this.ticket_id;
	modalRef.componentInstance.falg = this.falg
}
// export PMS ticket details
exportAsAllTicketsReport(): void {
	setTimeout(() => {
	  this.excelservice.exportAsExcelFile(this.ticket_details, 'Complaint_report');
	}, 1000);
  }
}
